export const STAGING_TS_CODES: Record<string, string> = {
  '40de3': 'Google',
  '584b0': 'Skyscanner',
  c1ac9: 'Kayak',
  '23548': 'Tripadvisor',
  '2cd1b': 'Vio.com',
  '6c508': 'Trivago',
  '39d61': 'Yandex',
};
export const PROD_TS_CODES: Record<string, string> = {
  '2f2fc': 'Google',
  '6be92': 'Skyscanner',
  '9b77c': 'Kayak',
  c7c57: 'Tripadvisor',
  '27a46': 'Vio.com',
  '6a97e': 'Trivago',
  '71a21': 'Yandex',
};

// Offline booking tsCode from PK
export const OFFICE_WALKIN_STAGING_TS_CODE = '58294';
export const OFFICE_WALKIN_PRODUCTION_TS_CODE = '42a2e';
